import {
    chakra,
    Box,
    FormControl,
    Button
} from '@chakra-ui/react';

import { ModalWrapper } from '../../../../../../../components/modal-wrapper';

export const UserProfileModalWrapper = chakra(ModalWrapper, {
    baseStyle: {
        'justifyContent': 'flex-start',
        'flexDirection': 'column',
        'h': 'calc(100% - 70px)',
        'overflow': 'auto',
        'maxHeight': '820px',
        '::-webkit-scrollbar-thumb': {
            borderTopRightRadius: '20px',
            borderBottomRightRadius: '20px'
        }
    }
});

export const UserProfileWrapper = chakra(Box, {
    baseStyle: {
        w: '100%',
        fontSize: '15px'
    }
});

export const CloseButtonWrapper = chakra(Box, {
    baseStyle: {
        display: 'flex',
        justifyContent: 'flex-end',
        w: '100%'
    }
});

export const CloseButton = chakra(Box, {
    baseStyle: {
        cursor: 'pointer',
        fontSize: '18px'
    }
});

export const Header = chakra(Box, {
    baseStyle: {
        display: 'flex',
        color: 'neutral.600'
    }
});

export const UserDetails = chakra(Box, {
    baseStyle: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        w: '100%'
    }
});

export const UserHeader = chakra(Box, { baseStyle: { fontSize: '28px' } });

export const Username = chakra(Box, {
    baseStyle: {
        fontSize: '20px',
        marginTop: '10px',
        textAlign: 'center'
    }
});

export const Form = chakra(FormControl, {
    baseStyle: {
        fontSize: '15px',
        color: 'neutral.700'
    }
});

export const Footer = chakra(Box, {
    baseStyle: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        fontSize: '12px'
    }
});

export const SaveButton = chakra(Button, {
    baseStyle: {
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'w': '100px',
        'h': '40px',
        'borderRadius': '20px',
        'm': '10px 0',
        'bgColor': 'primary.700',
        'fontSize': '18px',
        'color': 'neutral.50',
        'cursor': 'pointer',
        '&:disabled': { cursor: 'not-allowed' }
    }
});
